/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { InputNumber, Popover, Select } from 'antd';
import { countries } from 'countries-list';
import i18next from 'i18next';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { getPopupContainer } from '../../../helpers/popUp';

const dialCodes = Object.keys(countries).map(country => {
  return {
    name: country === 'XK' ? `+383` : `+${countries[country].phone.split(',')[0]}`,
    icon: countries[country].emoji,
    countryName: countries[country].name,
    countryCode: country,
    value: country === 'XK' ? `383` : `${countries[country].phone.split(',')[0]}`,
  }
}).sort((a, b) => (a.countryName > b.countryName ? 1 : b.countryName > a.countryName ? -1 : 0));

const Styles = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	flex-grow: 1;
	align-items: center;
  position: relative;
	.ant-select {
		max-width: 100px;

		.ant-select-selector {
			border-top-right-radius: 0;
      background-color: var(--base-gray-20);
			border-bottom-right-radius: 0;
		}
	}
	.ant-input-number {
		border-left: none;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;

    .ant-input-number-handler-wrap {
      display: none;
    }
  }

  &.has-error {
    .error-icon {
      position: absolute;
      right: 10px;
      color: red;
      top: 50%;
      transform: translate(0%, -50%);
    }
  }
`;

const TooltipStyle = styled.div`
  padding: 4px;

  h4 {
    margin-bottom: 2px;
    font-size: var(--font-size-lg);
    font-weight: 700;
  }

  p {
    margin-bottom: 0px;
    font-weight: 350;
    font-size: var(--font-size-lg);
  }
`;

export default function PhoneInput({
  defaultDialCode = null,
  initialValue = null,
  onChange,
  allowClear = false,
  country = null,
  size = "middle",
  ...props
}) {
  const phoneValidation = new RegExp(/\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/);
  const dialCodeValidation = new RegExp(/\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)/);
  const [dialCode, setDialCode] = useState();
  const [phoneNumber, setPhoneNumber] = useState(defaultDialCode);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (initialValue && typeof initialValue === 'string') {
      const value = (initialValue || '').split(' ').join('');
      if (phoneValidation.test(value)) {
        const [, dC, pN] = value.split(dialCodeValidation);
        setDialCode(dC);
        setPhoneNumber(pN);
      }
    }
  }, [initialValue])

  useEffect(() => {
    if (phoneNumber) {
      const chars = phoneNumber.toString().split('');
      if (chars.length === 9) {
        let formatted = '';
        chars.forEach((ch, i) => {
          if (i === 1 || i === 4) {
            formatted += `${ch} `;
          } else {
            formatted += ch;
          }
        });
        setError(false);
        const number = `+${[dialCode, formatted].join(' ')}`;
        if (onChange) onChange(number);
      } else {
        onChange(undefined);
        setError(true);
      }
    } else {
      onChange(undefined);
      setError(false);
    }
  }, [dialCode, phoneNumber]);
  useEffect(() => {
    if (country && (!dialCode || !phoneNumber)) {
      const c = dialCodes.find(d => d.countryCode.toLowerCase() === country.toLowerCase());
      if (c) {
        setDialCode(c.value);
      }
    }
  }, [country])
  return <Styles className={error ? 'has-error' : ''}>
    <Select
      {...getPopupContainer()}
      size={size} allowClear={allowClear} placeholder="Country code" filterOption={(inputValue, currOption) => {
        const stringOption = Array.isArray(currOption.children) ? (
          currOption.children[currOption.children.length - 1].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        ) : (
          typeof currOption.children === 'string' ? (
            currOption.children.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
          ) : ''
        );
        inputValue = inputValue.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        return stringOption.indexOf(inputValue) === 0;
      }} defaultActiveFirstOption showSearch optionFilterProp="children" defaultValue={dialCode} value={dialCode} onChange={code => setDialCode(code)}
    >
      {dialCodes.map((option, i) =>
        <Select.Option key={i} value={option.value}>
          {option.name}
        </Select.Option>
      )}
    </Select>
    <InputNumber
      size={size} allowClear={allowClear} type="number" placeholder={i18next.t("Type Number")} value={phoneNumber} onChange={number => setPhoneNumber(number)}
    />

    {error && (
      <Popover
        content={<TooltipStyle>
          <h4>{i18next.t('inputErrors::Phone number is not valid')}</h4>
          <p>{i18next.t('inputErrors::Please enter a valid number')}</p>
        </TooltipStyle>}
      >
        <div className="error-icon">
          <ExclamationCircleOutlined />
        </div>
      </Popover>
    )}
  </Styles>
};
